import classnames from "classnames";
import styles from "./TextCell.module.scss";
import type { Props } from "./types";
import { colors } from "./types";

// Text Cell with optional eyebrow, main text, and footer
export default function TextCell({
  alignment = "center",
  bold = false,
  className,
  eyebrow,
  footer,
  fontSize = "large",
  justification = "left",
  text,
  textColor = "abyss",
  uppercase = true
}: Props): React.JSX.Element {
  return (
    <div
      className={classnames(
        styles.container,
        className,
        styles[`${alignment}Alignment`],
        styles[`${justification}Justification`],
        styles[`${fontSize}FontSize`]
      )}
      style={{ color: colors[textColor] }}
    >
      <div className={styles.contents}>
        <span className={classnames(styles.eyebrow)}>{eyebrow}</span>
        <div
          className={classnames(
            styles.main,
            bold && styles.bold,
            uppercase && styles.uppercase
          )}
        >
          {text}
        </div>
        <span className={styles.footer}>{footer}</span>
      </div>
    </div>
  );
}
